<template>
  <div class="">
    <ChatLauncher v-if="!isOpen" @open-chat="openChat" />
    <ChatOverlay :isOpen="isOpen">
      <div
        class="w-full h-full bg-[#ffffff]/20 backdrop-blur-[35px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
      </div>
      <ChatHeader @close-chat="closeChat" />
      <img
        :src="avatarUrl"
        alt="Decoration"
        width="170px"
        height="170px"
        class="fixed top-2/3 left-[-30px] [@media(min-width:768px)]:left-1/4 w-16 h-16 z-54"
      />
      <ChatLoading v-if="isInitialLoading" />
      <ChatError v-else-if="!iscreateUserTokenValid" :initErrorMessage="initErrorMessage" />  
      <ChatContainer v-else>
        <!-- <ChatPlatformSelection v-if="this.platforms.length > 0"
          v-model="selected"
          :options="this.platforms"
          @update:modelValue="val => selected = val"
        /> -->
        <ChatMessages
          :messages="messages" :is-loading="isLoading" :debug="this.debug" :api-key="apiKey"
          @feedback="setFeedback" @donwload-file="donwloadFile" @answer="answerInteractive"
        />
        <ChatCommandPalette
          v-if="showPalette"
          :commands="filteredCommands"
          :is-loading="isLoadingCommands"
          @select="runCommand"
        />
        <ChatInput
          :input="input"
          :isLoading="isLoading" :isLoadingAudio="isLoadingAudio"
          @submit="sendMessage"
          @update:input="val => input = val"
          @audioRecorded="handleAudio"
        />
      </ChatContainer>        
      <button
        @click="openWhatsApp"
        class="fixed bottom-[50px] [@media(min-width:768px)]:bottom-[60px] right-1/10 [@media(min-width:768px)]:right-1/4 
        text-xl border-transparent font-bold z-50 rounded-full bg-[#1daa61]"
      >
      
        <img src="@/assets/whatsapp.svg" 
        width="50px"
        height="50px"
        alt="WhatsApp" class="w-8 h-8" />
      </button>
    </ChatOverlay>
  </div>
</template>

<script>
import ChatError from './ChatError.vue';
import ChatInput from './ChatInput.vue';
import ChatHeader from './ChatHeader.vue';
import ChatOverlay from './ChatOverlay.vue';
import ChatLoading from './ChatLoading.vue';
import ChatLauncher from './ChatLauncher.vue';
import ChatMessages from './ChatMessages.vue';
import ThumbsUpIcon from './ThumbsUpIcon.vue';
import ChatContainer from './ChatContainer.vue';
import ThumbsDownIcon from './ThumbsDownIcon.vue';
import ChatCommandPalette from './ChatCommandPalette.vue';
import ChatPlatformSelection from './ChatPlatformSelection.vue';

import { useChatWindow } from '../composables/useChatWindow'
import { useChatMessages } from '../composables/useChatMessages'
import { fetchChatData } from '../composables/useUserSession'
import { useNotifications } from '../composables/useNotifications'
import { lockStaleInteractions } from '../utils/interactions'
import { getCommands } from '../services/commandsApi'
import { useNotificationsSocket } from '../composables/useNotificationsSocket'
import { initPush, getDeviceToken, onForegroundMessage } from '../services/push'
import { registerDevice, deleteDevice } from '../services/notificationsApi'

export default {
  data() {
    return {
      selected: null,
      isOpen: false,
      isLoading: false,
      isInitialLoading: false,
      isLoadingAudio: false,
      iscreateUserTokenValid: false,
      initErrorMessage: null,
      email: null,
      username: null,
      phone: null,
      apiKey: null,
      sessionId: null,
      createUserToken: null,
      debug: null,
      input: '',
      messages: [],
      deviceToken: null,
      socket: null,
      commands: [],
      commandsLoaded: false,
      isLoadingCommands: false,
      avatarUrl: require(`@/assets/${process.env.VUE_APP_AVATAR_URL}`),
      whatsapp: process.env.VUE_APP_WHATSAPP_NUMBER
    };
  },
  computed: {
    // "/" at the start of the input opens the command palette.
    isCommandMode() {
      return this.input.startsWith('/')
    },
    commandQuery() {
      return this.input.slice(1).trim().toLowerCase()
    },
    filteredCommands() {
      if (!this.commandQuery) return this.commands
      return this.commands.filter(c =>
        `${c.label} ${c.description || ''} ${c.id}`.toLowerCase().includes(this.commandQuery)
      )
    },
    showPalette() {
      return this.isCommandMode && (this.isLoadingCommands || this.commands.length > 0)
    }
  },
  watch: {
    input(val) {
      if (val.startsWith('/')) this.loadCommands()
    }
  },
  components: {
    ChatError,
    ChatInput,
    ChatHeader,
    ChatLoading,
    ChatOverlay,
    ChatMessages,
    ThumbsUpIcon,
    ChatLauncher,
    ChatContainer,
    ThumbsDownIcon,
    ChatCommandPalette,
    ChatPlatformSelection,
  },
  methods: {
  serverLog(payload) {
  try {
    const apiUrl = process.env.VUE_APP_API_URL
    fetch(`${apiUrl}/client-log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.href,
        time: Date.now(),
        ...payload
      })
    });
  } catch (e) {
    console.log(e);
  }
},
     openWhatsApp() {
      window.open(`https://wa.me/${this.whatsapp}?text=Hola Richie`, '_blank');
    },
    closeChat(){
      window.parent.postMessage("close-chat", "*");
      if (typeof window.ChatChannel !== "undefined") {
        window.ChatChannel.postMessage("close-chat");
      }
      this.$emit('close-chat');
      this.isOpen = false
    },
    openChat() {
      this.serverLog({
        tag: 'openChat',
        windowParent: !!window.parent,
        sameAsParent: window === window.parent,
        chatChannel: typeof window.ChatChannel,
        windowKeys: Object.keys(window).filter(k => k.toLowerCase().includes('chat'))
      });

      try {
        window.parent.postMessage("open-chat", "*");
        this.serverLog({ tag: 'postMessage', status: 'sent' });
      } catch (e) {
        this.serverLog({ tag: 'postMessage', error: e.toString() });
      }

      if (typeof window.ChatChannel !== "undefined") {
        try {
          window.ChatChannel.postMessage("open-chat");
          this.serverLog({ tag: 'ChatChannel', status: 'sent' });
        } catch (e) {
          this.serverLog({ tag: 'ChatChannel', error: e.toString() });
        }
      } else {
         this.serverLog({ tag: 'ChatChannel', status: 'undefined' });
      }

      this.$emit('open-chat');
      console.log('[openChat] vue emit fired');

      const { scrollToBottom } = useChatWindow();
      this.isOpen = true;

      if (!this.iscreateUserTokenValid) {
        console.warn('[openChat] user token NOT valid');
        return;
      }

      // Merge messages that arrived over the socket while the chat was closed into the
      // thread, preceded by a one-time "Mensajes no leídos" divider. Then mark read.
      this.mergeUnreadIntoThread();
      const { markSessionRead } = useNotifications();
      markSessionRead(this.apiKey, this.sessionId);

      this.$nextTick(() => {
        console.log('[openChat] nextTick -> scrolling');
        scrollToBottom(this.$el);
      });
    },

    // Append unread messages for the current session that aren't already in the thread,
    // with a fresh "unread" divider before them. Removes any stale divider from a prior open.
    mergeUnreadIntoThread() {
      const { state } = useNotifications();

      // Drop a divider left over from a previous open so it doesn't persist.
      this.messages = this.messages.filter(m => m.messageType !== 'unread_divider');

      const existingIds = new Set(this.messages.map(m => m.id).filter(Boolean));
      const newItems = state.items
        .filter(m => m.sessionId === this.sessionId)
        .filter(m => !m.id || !existingIds.has(m.id))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      if (newItems.length === 0) return;

      this.messages.push({ messageType: 'unread_divider' });
      this.messages.push(...newItems);
      lockStaleInteractions(this.messages);
    },

    // Catalog is fetched once per session, on the first "/" typed.
    async loadCommands() {
      if (this.commandsLoaded || this.isLoadingCommands || !this.apiKey) return
      this.isLoadingCommands = true
      try {
        const data = await getCommands(this.apiKey)
        this.commands = Array.isArray(data.commands) ? data.commands : []
        this.commandsLoaded = true
      } catch (e) {
        console.error('[commands] load failed', e)
      } finally {
        this.isLoadingCommands = false
      }
    },

    async runCommand(cmd) {
      if (!cmd) return
      const { sendCommand } = useChatMessages()
      const { scrollToBottom } = useChatWindow()

      this.input = ''
      await sendCommand({
        apiKey: this.apiKey,
        sessionId: this.sessionId,
        command: cmd.id,
        label: cmd.label,
        messages: this.messages,
        setLoading: val => (this.isLoading = val),
        scrollToBottom: () => scrollToBottom(this.$el)
      })
    },

    async handleAudio(file) {
      try {
        this.isLoadingAudio = true;
        const apiUrl = process.env.VUE_APP_API_URL
        const formData = new FormData();
        // Convert blob to File to simulate real file upload
        const audioFile = new File([file], 'recording.webm', { type: 'audio/webm' });
        formData.append('audio_file', audioFile);

        const response = await fetch(`${apiUrl}/chat-messages/transcribe`, {
          method: 'POST',
          headers: {
             'apiKey': this.apiKey,
          },
          body: formData,
        });

        const result = await response.json();
        console.log('🎤 Transcription result:', result);
        this.input = result.text
        this.isLoadingAudio = false;
      } catch (err) {
        console.error('❌ Error sending audio:', err);
        this.isLoadingAudio = false;
      }
    },
    async sendMessage() {
      // While the palette is open, Enter/send picks the highlighted command instead of sending text.
      if (this.showPalette && this.filteredCommands.length > 0) {
        return this.runCommand(this.filteredCommands[0])
      }

      const { sendMessage } = useChatMessages()
      const { scrollToBottom } = useChatWindow()

      await sendMessage({
        apiKey: this.apiKey,
        sessionId: this.sessionId,
        input: this.input,
        messages: this.messages,
        setInput: val => (this.input = val),
        setLoading: val => (this.isLoading = val),
        scrollToBottom: () => scrollToBottom(this.$el),
        platform: this.selected
      })
    },

    // Answer an interactive message: keep it visible but locked, then stream the reply.
    async answerInteractive({ msg, answer, summary }) {
      if (msg.answered) return
      msg.answered = true
      msg.answerSummary = summary

      const { sendAnswer } = useChatMessages()
      const { scrollToBottom } = useChatWindow()

      await sendAnswer({
        apiKey: this.apiKey,
        sessionId: this.sessionId,
        interactionId: msg.payload?.interactionId,
        answer,
        messages: this.messages,
        setLoading: val => (this.isLoading = val),
        scrollToBottom: () => scrollToBottom(this.$el)
      })
    },

    setFeedback(msg, value) {
      const { setFeedback } = useChatMessages()
      setFeedback(msg, value, this.apiKey)
    },

    donwloadFile(url) {
      const { donwloadFile } = useChatMessages()
      donwloadFile(url, this.apiKey)
    },

    async fetchChatData() {
      const { scrollToBottom } = useChatWindow()
      const setSession = ({ valid, apiKey, sessionId, errorMsg, messages }) => {
        this.iscreateUserTokenValid = valid
        if (valid) {
          this.apiKey = apiKey
          this.sessionId = sessionId
          this.messages = messages
          // Only the newest prompt stays live after a reload.
          lockStaleInteractions(this.messages)
          scrollToBottom(this.$el)
        } else {
          this.initErrorMessage = errorMsg
        }
      }

      await fetchChatData({
        email: this.email,
        username: this.username,
        createUserToken: this.createUserToken,
        phone: this.phone,
        setSession
      })
    },

    // Register device for push, load unread badge, open the realtime socket.
    async initNotifications() {
      const { fetchUnread, addIncoming } = useNotifications()

      // Device token (FCM, with localStorage fallback) — also used as the WS deviceToken.
      try {
        await initPush()
        const { token } = await getDeviceToken()
        this.deviceToken = token
        await registerDevice(this.apiKey, token)
      } catch (e) {
        console.error('[notifications] device registration failed', e)
      }

      // Foreground push -> bump badge.
      onForegroundMessage((payload) => {
        const msg = payload?.data || payload?.notification
        if (msg) addIncoming(msg)
      })

      // Initial unread count.
      fetchUnread(this.apiKey)

      // Realtime socket.
      const wsUrl = process.env.VUE_APP_WS_URL
      if (wsUrl && this.deviceToken) {
        this.socket = useNotificationsSocket()
        this.socket.connect({
          wsUrl,
          apiKey: this.apiKey,
          deviceToken: this.deviceToken,
          onChatMessage: this.onChatMessage
        })
      }

      // Tab close: best-effort teardown (beforeUnmount won't fire on tab close).
      window.addEventListener('beforeunload', this.teardownNotifications)
    },

    onChatMessage(message) {
      if (!message) return
      const { addIncoming, markSessionRead } = useNotifications()
      const { scrollToBottom } = useChatWindow()

      const forCurrentSession = message.sessionId === this.sessionId
      if (forCurrentSession && this.isOpen) {
        // Live append to the open thread, dedupe by id, then mark read.
        if (!message.id || !this.messages.some(m => m.id === message.id)) {
          this.messages.push(message)
          lockStaleInteractions(this.messages)
          this.$nextTick(() => scrollToBottom(this.$el))
        }
        markSessionRead(this.apiKey, this.sessionId)
      } else {
        addIncoming(message)
      }
    },

    teardownNotifications() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
      if (this.apiKey && this.deviceToken) {
        // Best-effort; page may be unloading.
        deleteDevice(this.apiKey, this.deviceToken).catch(() => {})
      }
    }
  },
  async created(){
    this.isInitialLoading = true;
    const urlParams = new URLSearchParams(window.location.search);
    this.createUserToken = urlParams.get('createUserToken');
    this.email = urlParams.get('email');
    this.username = urlParams.get('username');
    this.phone = urlParams.get('phone')
    this.debug= urlParams.get('debug');
    this.selected= urlParams.get('platform');
    // this.platforms = urlParams.get('platforms')
    const platformsParam = urlParams.get('platforms');
    if (platformsParam) {
      try {
        this.platforms = JSON.parse(decodeURIComponent(platformsParam));
        
      } catch (e) {
        console.error('Invalid platforms param', e);
        this.platforms = [];
      }
    } else {
      this.platforms = [];
    }
    if (this.platforms.length > 0) {
      this.selected = this.platforms[0].value;
    }
    await this.fetchChatData();
    this.isInitialLoading = false;

    if (this.iscreateUserTokenValid) {
      await this.initNotifications();
    }
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.teardownNotifications);
    this.teardownNotifications();
  }
};
</script>

<style scoped>
/* Animation for chat window */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
